import { Box, Dialog, Grow } from '@mui/material'
import { useContext } from 'react'

import { AppContext } from '../../providers/AppProvider/AppProvider'
import { CustomerEntry } from '../../sdk'
import { SlideUpDialogTransition } from '../SharedUI/SlideUpDialogTransition'
import CustomerChatPanel from './CustomerChatPanel'

interface Props {
  customerChatIsOpen: boolean
  setCustomerChatIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  customer: CustomerEntry
  generateRoSummary?: () => Promise<string>
}

const CustomerChatPanelWrapper = ({
  customerChatIsOpen,
  setCustomerChatIsOpen,
  customer,
  generateRoSummary
}: Props) => {
  const { overTabletBreakpoint } = useContext(AppContext)

  return (
    <>
      {overTabletBreakpoint ? (
        <Grow in={customerChatIsOpen}>
          <Box>
            <CustomerChatPanel
              customerChatIsOpen={customerChatIsOpen}
              setCustomerChatIsOpen={setCustomerChatIsOpen}
              customerOfRepairOrder={customer}
              generateRoSummary={generateRoSummary}
            />
          </Box>
        </Grow>
      ) : (
        <Dialog
          fullScreen
          open={customerChatIsOpen}
          onClose={() => {
            setCustomerChatIsOpen(false)
          }}
          TransitionComponent={SlideUpDialogTransition}
          keepMounted>
          <CustomerChatPanel
            customerChatIsOpen={customerChatIsOpen}
            setCustomerChatIsOpen={setCustomerChatIsOpen}
            customerOfRepairOrder={customer}
            generateRoSummary={generateRoSummary}
          />
        </Dialog>
      )}
    </>
  )
}

export default CustomerChatPanelWrapper
